export enum TagOrientation {
  horizontal,
  vertical,
}

export enum TagTypes {
  discount,
  note,
  noIcon,
  success,
  star,
  person,
  purpleStar,
}

export enum TagSize {
  xs,
  sm,
  lg,
  linkBreak,
}

export enum TagBgColour {
  infoBlue,
  note,
  error,
  success,
  trueWhite,
  antiFlashWhite,
  lightHighlightPurple,
}

export enum TagBorderColour {
  none,
  darkblue,
  orange,
  red,
  green,
  lightblue,
}
